import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/subscribe`, { email, name: name || null });
      toast.success("You're on the list. Welcome to Listen.");
      setEmail("");
      setName("");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong. Try again.";
      toast.error(typeof msg === "string" ? msg : "Subscription failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="subscribe" data-testid="newsletter-section" className="relative bg-[#2AC1E0]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#2E1A6B] mb-4">
              The Digital Subscription
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-[#2E1A6B]">
              Quarterly issues.<br />Weekly dispatches.<br />
              <span className="italic">In your inbox.</span>
            </h2>
            <p className="mt-6 text-[#2E1A6B]/85 text-base md:text-lg max-w-xl">
              Get the digital edition, subscriber-only interviews, scholarship alerts, and early
              access to National Service Diaries — no spam, ever.
            </p>
          </div>

          <form onSubmit={submit} data-testid="newsletter-form" className="lg:col-span-5 flex flex-col gap-3">
            <div>
              <label htmlFor="nl-name" className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#2E1A6B]">
                Name (optional)
              </label>
              <input
                id="nl-name"
                data-testid="newsletter-name-input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ama Serwaa"
                className="mt-2 w-full bg-transparent border-b border-[#2E1A6B]/40 focus:border-[#2E1A6B] outline-none py-3 text-lg text-[#2E1A6B] placeholder:text-[#2E1A6B]/40"
              />
            </div>
            <div className="mt-2">
              <label htmlFor="nl-email" className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#2E1A6B]">
                Email address
              </label>
              <input
                id="nl-email"
                data-testid="newsletter-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@school.edu.gh"
                className="mt-2 w-full bg-transparent border-b border-[#2E1A6B]/40 focus:border-[#2E1A6B] outline-none py-3 text-lg text-[#2E1A6B] placeholder:text-[#2E1A6B]/40"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit-btn"
              className="mt-6 inline-flex items-center justify-center gap-2 px-6 py-4 bg-[#2E1A6B] text-white text-sm uppercase tracking-[0.2em] font-semibold hover:bg-[#1A0F44] transition-colors disabled:opacity-60"
            >
              {loading ? "Subscribing..." : "Subscribe to Listen"}
              <ArrowUpRight size={18} />
            </button>
            <p className="text-[11px] uppercase tracking-[0.2em] text-[#2E1A6B]/70">
              Free forever · Unsubscribe anytime
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}
